export default __webpack_public_path__ + "partner_16507d36.png";